import request from '@/utils/request';

/**角色列表 */
export const userRoleList = ()=>{
    return request
    .get('/api/Setting/Role/list', {})
}